export default function isEditingProfessionSelector(state: Store): boolean {
    return state.profession.isEditing;
}
